<section class="flex justify-content-center mt-4">
    <div class="card-table col-12">
        <p-tabView [(activeIndex)]="activeTabIndex" (activeIndexChange)="activeIndexChange($event)" class="w-full">
            <p-tabPanel [header]="'components.app-admin-usuarios.usuarios' | translate">
                <app-usuarios></app-usuarios>
            </p-tabPanel>
            <p-tabPanel [header]="'components.app-admin-usuarios.dependencias' | translate">
                <app-dependencias-usuario></app-dependencias-usuario>
            </p-tabPanel>
        </p-tabView>
    </div>
</section>